export const languageHashValues= {
  "GLOBAL": ".15b135272d3e488ccb94",
  "U4302_TRANSACTIONSDETAIL": ".099e5ae64f5d1525cdce",
  "U4400_PAYMENT": ".bcf857d082ca890a19ae",
  "U5122_INVOICEMODIFICATIONAPPROVAL": ".a46d5a9ceb47fe0afd23",
  "U2117_PADAGREEMENTINVITATION": ".77bad6519c2c6b9336ab",
  "U2000_PAD": ".b13f9f823e69bf0f2272",
  "U4402_INVOICEPORTALPAYMENT": ".af493012ea89559bd566",
  "U2000_BANKACCOUNTCREATION": ".e2eceaef507827b33190",
  "U2011_LOGIN": ".395f85f55e6ce176474b",
  "U2012_LOGINHELP": ".13ca518f5cd153a9fe30",
  "U2014_SECURITY": ".1f7a2c41c404afd50a55",
  "U2086_EFTPENDINGPAYMENTS": ".fd9124618830cca5e32d",
  "U2087_EFTPAYMENTSNOTIFICATIONS": ".92bbabe4f94d3bd6c0e6",
  "U2110_ACCOUNTCREATION": ".b7f9be404f5881a6acaa",
  "U2121_INDIVIDUALPROFILE": ".36b7a81283510c1c73f1",
  "U2131_ORGANIZATIONPROFILE": ".745511e3dc7036ebfb2b",
  "U2112_ERPBINDING": ".2a34c84680761e50d269",
  "U2113_SUPPLIERINVITATION": ".4b5402958e45bb91e8d4",
  "U2132_AFFILIATION": ".57d40b616f4e7685b4e4",
  "U2133_BUSINESSLINKS": ".0874fa2fc5095fcfe83d",
  "U2181": ".22b58e2de9f41541028a",
  "U2211_SUBSCRIPTIONOFFER": ".a7a9cd09a0427976b7df",
  "U2212_SUBSCRIPTIONFILTER": ".78bb48ae8a3753b35dce",
  "U2213_SUBSCRIPTION": ".889495b5e8cb2f8cc7e5",
  "U4111_CREDITCARDADDITION": ".2f9b7147bc09192f68f5",
  "U4112_CREDITCARDDETAIL": ".92889a9392e76d689e46",
  "U4121_BANKACCOUNTADDITION": ".814f48ea9d1d79b3763c",
  "U4122_BANKACCOUNTDETAIL": ".a19624dcd8dd0402b2c3",
  "U4303_ANONYMOUSTRANSACTION": ".20006542f6879c2d1ad0",
  "U4401_PAYMENTGATEWAY": ".53c7cde4f50abd1a7156",
  "U4481_PROCESSINVOICEINSTALMENTPAYMENTS": ".65d358eb9eccd480b6b3",
  "U5000_RECEIVABLE": ".355a9408a66bfaa2da1b",
  "U5101_STATEMENTOFACCOUNT": ".0c8b6e69dea1bb92e63c",
  "U5102_INVOICE": ".eed2c13d1bde1c5ff853",
  "U5103_PADAGREEMENT": ".662b3c74837e93a406dc",
  "U5121_SENTINVOICE": ".3f89346c5fb6a50ef3cd",
  "U5124_PGRECEIVEDPAYMENT": ".57e20cbbc02d62545346",
  "U5120_INVOICES": ".d83d088b0ec487100484",
  "U5123_PADAGREEMENTCONSOLE": ".4dfc40a6fa7c5a6f029d",
  "U5132_PAYMENTRECONCILIATION": ".9e0767a306df4b5e5e4c",
  "U5133_BANKRECONCILIATION": ".ef490334266d021c76ea",
  "U6112_BUSINESSLINK": ".56030f0f3b569874239a",
  "U6113_SUPPLIERRECORD": ".e280f57279b974d69f3a",
  "U6211_PAYLOT": ".6cb395dd626ae66b26b0",
  "U6311_PURCHASE": ".3e3be25038f3dede743c",
  "U2115_AFFILIATIONINVITATION": ".0f773e51c899610dcd94",
  "U6100_PAYABLE": ".0dd90d78fd6e0533277d",
  "U6131_SENTPAYMENT": ".c2868d385ec06d14d69e",
  "U6191_SENTPAYMENTREPORT": ".239886e38969ade5775d",
  "U6221_SENTPAYMENT": ".2fdc89258bed832c4c20",
  "U6422_INTERACSENTPAYMENT": ".8450914d8b2936671717",
  "U6531_TRANSACTIONPAYMENT": ".936110618a7fe76d0131",
  "U5131_RECEIVEDPAYMENT": ".341c7de49440390ea5bf",
  "U5191_RECEIVEDPAYMENTREPORT": ".11f9f548aac2e538e26e",
  "U6141_INVOICEDATA": ".f612a8cc4fb1fd514572",
  "U6142_INVOICEDATA": ".4238910c4dc0ba411cce",
  "U2001_HOME": ".34c4c8ef48bee3c1bb05",
  "U2024_REPORTLOG": ".50ef76bc8cb9598d0d7d",
  "U2111_INVOICEPORTALBINDING": ".c87ffbd5fea0a47d5037",
  "U2116_ANONYMOUSSUPPLIERINVITATION": ".d5e09657adfd462e05c0",
  "U6111_SUPPLIERINVITATIONCONSOLE": ".e5195cc86ec77ffa20ba",
  "U6511_TRANSACTIONPARTY": ".78c1f10f1d17b0daa4db",
  "U6212_PAYROLLPARTY": ".3cd1b616ef6a904a8ca2",
  "U6121_EFTLOT": ".83227b8e01cda133c46d",
  "U6412_INTERACFILE": ".7b636b08a917870f8cb7",
  "U6122_EFTAPPROVAL": ".d1856306ccb32b915793",
  "U6512_TRANSACTIONLOT": ".3fc30431ff25120a2958",
  "U2027_EFTLOT": ".8dd5f93978fda7d6bbf4",
  "U6123_EFTAPPROVAL": ".a1954d46c4e4d473c2bd",
  "U6123_EFTAPPROVALMOBILE": ".26dac829036173866128",
  "U2012_LOGIN": ".960f639c62443b615b29",
  "U6611_RESELLERCLIENT": ".50bf365a4ba9af3c42f8",
  "U2000_PAYMENT": ".0efa4bc11fdf59d2b6b5",
  "U4101_CREDITCARDBANKACCOUNTSUMMARY": ".3d7ab8e42eb4f30501db",
  "U2000_PAYMENTMODEUPDATE": ".e7a13df8ffaea3a1a563",
  "U6114_TELUSBILLER": ".719fe51490cec2c04c65",
  "U4403_CREDITCARDTERMINAL": ".836c00f5d41345aa7928",
  "U4404_INTERACTERMINAL": ".e848c9c08483cd0ac9bc",
  "U2000_SAMPLECHEQUESELECTION": ".7e8a3fdd6fa1dc3e7685",
  "U2023_TUTORIALVIDEO": ".efb5b737cf43258931b5",
  "U2134_ORGANIZATIONBILLING": ".af383e0d9b862cc97d38",
  "U6414_BANKACCOUNTWALLET": ".cb50dac66eb2d3d79ee0",
  "U2022_INSTANTACCOUNTVERIFICATION": ".d3d5a4937dbe63fd98b0",
  "U6532_PENDINGTRANSACTION": ".a3cf5b86dff08009e56a",
  "U4301_TRANSACTIONSSUMMARY": ".9af5c5adeb1417f166bb",
  "U2026_NETPROMOTERSCORE": ".4f9c3adfc3ca8f588be5",
  "U2000_ACCOUNTPERSONNALINFORMATIONS": ".d8701083f17455b18a28",
  "U2000_INTRO": ".2f3c132bdaba8ada3e88",
  "U2000_ATTACHMENTVIEWER": ".2348d2eded58f0adbcb5",
  "U2000_ELECTRONICSIGNATURE": ".398f9d880ec0844fbed3",
  "U2000_VERIFYEMAIL": ".e3cdc3105381c6bb606c",
  "U2200_SUBSCRIPTION": ".1e59272091de1b533c7c",
  "U2118_RBBINDING": ".a7a934130c6f2b94fdf8",
  "U2028_RELEASENOTE": ".c4b673acf7f55f7eb442",
  "U2000_VERIFYIDENTITY": ".1f9429f6cfbc57c085e3",
  "U2212_PLANLIST": ".8ecd0f2d41290e64ae95",
  "U3002_TAXBILLSEARCHRESULT": ".560ca577dd89fada4522"
}